<template>
  <div>
    <PageAllow controller="Payment" action="getPaySettings" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("Payment.LCSWPay.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <!-- lcsw_url -->
              <v-row class="mt-5">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.LCSWPay.lcsw_url") + $t("Global.colon") }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LCSWPay.lcsw_url')"
                    rules="required"
                  >
                    <v-textarea
                      v-model="lcswSettings.lcsw_url"
                      outlined
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lcsw_url')
                          .concat(errors)
                      "
                    >
                    </v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- lcsw_merchant_no -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LCSWPay.lcsw_merchant_no") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LCSWPay.lcsw_merchant_no')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="lcswSettings.lcsw_merchant_no"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lcsw_merchant_no')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <!-- lcsw_terminal_id -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LCSWPay.lcsw_terminal_id") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LCSWPay.lcsw_terminal_id')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="lcswSettings.lcsw_terminal_id"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lcsw_terminal_id')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <!-- lcsw_access_token -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LCSWPay.lcsw_access_token") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LCSWPay.lcsw_access_token')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="lcswSettings.lcsw_access_token"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lcsw_access_token')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- lcsw_commission -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LCSWPay.lcsw_commission") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.LCSWPay.lcsw_commission')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="lcswSettings.lcsw_commission"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'lcsw_commission')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- lcswpay_enable -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.LCSWPay.lcswpay_enable") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="lcswSettings.lcswpay_enable">
                    <v-radio :label="$t('Payment.off')" key="0" value="0" />
                    <v-radio :label="$t('Payment.on')" key="1" value="1" />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                color="success"
                block
                @click="
                  lcswSettings.lcswpay_enable == 1
                    ? (alertDialog = true)
                    : save()
                "
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("Payment.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>

    <DialogAlert
      v-model="alertDialog"
      :message="$t('Payment.change_wechat_pay', [$t('Payment.lcswpay')])"
      useConfirm
      @confirm="save()"
    />
  </div>
</template>

<script>
import Payment from "@/api/payment";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import DialogAlert from "@/components/plugins/DialogAlert";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  data: () => ({
    lcswSettings: {},
    serverErrors: [],
    alertDialog: false,
  }),

  components: {
    PageAllow,
    Breadcrumbs,
    DialogAlert,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.payment"),
        disabled: true,
        href: "/payment",
      },
    ],
    ...mapState(["loading", "settings"]),
  },

  mounted() {
    this.getAlipayFromAPI();
  },

  methods: {
    getAlipayFromAPI() {
      Payment.fetch({
        keys: [
          "lcsw_url",
          "lcsw_merchant_no",
          "lcsw_terminal_id",
          "lcsw_access_token",
          "lcsw_commission",
          "lcswpay_enable",
        ],
        parse: 0,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.lcswSettings = response.data.settings;

            if (
              this.lcswSettings.lcswpay_enable == null ||
              typeof this.lcswSettings.lcswpay_enable == "undefined" ||
              this.lcswSettings.lcswpay_enable == undefined
            ) {
              this.lcswSettings.lcswpay_enable = "0";
            }
          }
        }.bind(this)
      );
    },

    save() {
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            Payment.LCSWPaySave(this.lcswSettings).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$router.push("/payment");
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
  },

  watch: {},
};
</script>